/* =============================================================================
   Farmoxa Premium — quote form prefill: /pages/offerte-aanvragen?product=<handle>[&variant=<id>]
   Reads the product through the storefront JSON endpoint and fills the product field + preview card.
   ============================================================================= */
(() => {
  'use strict';
  const root = document.querySelector('[data-fmx-contact][data-mode="quote"]');
  if (!root) return;
  const params = new URLSearchParams(location.search);
  const handle = (params.get('product') || '').trim();
  if (!handle || !/^[a-z0-9-]+$/i.test(handle)) return;
  const field = root.querySelector('[data-fmx-quote-field]');
  const urlField = root.querySelector('[data-fmx-quote-url]');
  const card = root.querySelector('[data-fmx-quote-product]');
  const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const variantId = params.get('variant');

  fetch(`${rootUrl}products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } })
    .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
    .then((p) => {
      const variant = (p.variants || []).find((v) => String(v.id) === String(variantId)) || (p.variants || [])[0] || {};
      const parts = [p.title];
      if (variant.title && variant.title !== 'Default Title') parts.push(variant.title);
      if (variant.sku) parts.push(`SKU ${variant.sku}`);
      const text = parts.join(' – ');
      if (field && !field.value) field.value = text;
      const productUrl = `${location.origin}${rootUrl}products/${p.handle}${variant.id ? `?variant=${variant.id}` : ''}`;
      if (urlField) urlField.value = productUrl;
      if (card) {
        const img = card.querySelector('[data-fmx-quote-img]');
        const src = (variant.featured_image && variant.featured_image.src) || p.featured_image || '';
        if (img && src) { img.src = src.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x160$1$2'); img.alt = p.title; img.hidden = false; }
        const title = card.querySelector('[data-fmx-quote-title]');
        if (title) title.textContent = p.title;
        const meta = card.querySelector('[data-fmx-quote-meta]');
        if (meta) meta.textContent = [variant.title !== 'Default Title' ? variant.title : '', variant.sku ? `SKU ${variant.sku}` : '', p.vendor].filter(Boolean).join(' · ');
        const link = card.querySelector('[data-fmx-quote-link]');
        if (link) link.href = productUrl;
        card.hidden = false;
      }
    })
    .catch(() => { if (field && !field.value) field.value = handle; });
})();
